<template>
  <div
    id="workflow-review-scrollable-content"
    ref="scrollableContent"
    style="overflow-x: hidden; position: relative; overflow-anchor: none"
    :style="heightAboveContainer"
    class="tw-overflow-y-scroll"
    @scroll="handleScroll"
  >
    <slot v-bind="{ observer, getScrollableRef }" />
  </div>
</template>

<script>
import { nextTick } from 'vue'

import { FOCUS_BAND_TOP_PERCENT } from '../services/focused-scroll-anchor'

export default {
  props: {
    currentIndex: Number,
  },
  emits: ['item-focused', 'scroll'],
  data() {
    return {
      currentElement: null,
      observer: null,
      spaceAbove: 0,
    }
  },
  computed: {
    heightAboveContainer() {
      return {
        height: 'calc(100vh - ' + Math.round(this.spaceAbove + 1) + 'px)',
      }
    },
  },
  mounted() {
    this.observer = new IntersectionObserver(
      (entries) => {
        const entry = entries.sort(
          (a, b) => b.intersectionRatio - a.intersectionRatio
        )[0]
        const isIntersecting = entry && entry.isIntersecting
        if (!isIntersecting) return

        this.currentElement = entry.target
        this.emitItemFocused(entry.target.dataset.index)
      },
      {
        root: this.$refs.scrollableContent,
        // A 0.1%-high band starting FOCUS_BAND_TOP_PERCENT down the container:
        // whatever item crosses it is the focused one.
        rootMargin: `-${FOCUS_BAND_TOP_PERCENT}% 0px -${
          100 - FOCUS_BAND_TOP_PERCENT - 0.1
        }% 0px`,
        threshold: 0,
      }
    )

    nextTick(() => {
      this.spaceAbove = this.$refs.scrollableContent.getBoundingClientRect().top
    })
  },
  beforeUnmount() {
    this.observer?.disconnect()
    this.observer = null
  },
  methods: {
    handleScroll(event) {
      this.$emit('scroll', event)
    },
    emitItemFocused(index) {
      this.$emit('item-focused', parseInt(index))
    },
    getScrollableRef() {
      return this.$el
    },
  },
}
</script>
